import React, { FC } from 'react'
import styled from 'styled-components'
import { CleanButton } from '../CleanButton'
import { Box } from '../Layout'

const Bullet = styled(Box)`
  transform: rotate(45deg);
  transition: background 0.2s ease;
  background: currentColor;
`

Bullet.defaultProps = {
  mr: ['0.5rem', '0.75rem'],
  height: ['4px', '5px'],
  width: ['4px', '5px']
}

type Props = {
  active: number
  total: number
  onClickItem?: (index: number) => void
}

export const SliderIndicators: FC<Props> = ({ active, total, onClickItem }) => {
  return (
    <>
      {[...Array.from(new Array(total))].map((_, index) => (
        <CleanButton
          key={`indicator-${index}`}
          color={active === index ? 'shades.800' : 'shades.400'}
          size={20}
          onClick={() => onClickItem(index)}
        >
          <Bullet />
        </CleanButton>
      ))}
    </>
  )
}

export default SliderIndicators
